/**
 * BusinessNearMe Logo — inline SVG component.
 *
 * Concept: A blue rounded-square app-icon containing a white
 * teardrop location-pin.  Inside the pin's head, three horizontal
 * bars suggest a business-directory listing.
 *
 *   Blue rounded square  →  brand, trustworthy, "app" feel
 *   White teardrop pin   →  location / "near me"
 *   Three listing bars   →  directory / business listings
 *
 * The SVG has no hard-coded width/height; sizing is handled
 * entirely by CSS (via className) so the logo scales correctly
 * at every breakpoint without extra JavaScript.
 */

function Logo({ className = "logo-icon", style = {} }) {
  return (
    <svg
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: "block", flexShrink: 0, ...style }}
      aria-label="BusinessNearMe"
      role="img"
    >
      {/* ── Blue rounded-square background ───────────────────── */}
      <rect width="36" height="36" rx="8" fill="#1a73e8" />

      {/* ── White teardrop pin ────────────────────────────────
          Path: smooth cubic-bezier teardrop.
          Wide at (7,16)/(29,16), narrows to a point at (18,31).
          The head circle spans roughly y=5..25, x=7..29.       */}
      <path
        d="M18 5
           C24.627 5 29 9.373 29 16
           C29 22.627 23.5 27 18 31
           C12.5 27 7 22.627 7 16
           C7 9.373 11.373 5 18 5Z"
        fill="white"
      />

      {/* ── Three listing bars (directory concept) ────────────
          All bars fit safely within the pin-head's white area.
          - Bar 1: y ≈ 10.5  (upper area)
          - Bar 2: y ≈ 14.5  (middle)
          - Bar 3: y ≈ 18.5  (lower, shorter = classic list look)

          At each y, the pin half-width ≫ bar width so no overflow.  */}
      <rect x="12.5" y="10.5" width="11"  height="2.2" rx="1.1" fill="#1a73e8" />
      <rect x="12.5" y="14.5" width="11"  height="2.2" rx="1.1" fill="#1a73e8" />
      <rect x="12.5" y="18.5" width="7.5" height="2.2" rx="1.1" fill="#1a73e8" />
    </svg>
  );
}

export default Logo;
